import React, { useEffect, useState, useRef } from 'react';
import { Phone, Check, Users } from 'lucide-react';
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';

const Aboutarea = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const [isExpanded, setIsExpanded] = useState(false);
  const textRef = useRef(null); // Create a ref to get the element's height
  const [textHeight, setTextHeight] = useState('7.5rem'); // Set an initial height

  useEffect(() => {
    if (textRef.current) {
      // Get the full height of the element
      const scrollHeight = textRef.current.scrollHeight;
      // Set the height based on whether it's expanded or not
      setTextHeight(isExpanded ? `${scrollHeight}px` : '3.5rem'); // Adjust initial height as needed
    }
  }, [isExpanded]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-gray-50 py-16 lg:py-24">
      <div className="containers mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Side - Images */}
          <div className="order-2 lg:order-1 relative" data-aos="fade-up">
            <div className="grid grid-cols-2 gap-4 lg:gap-6">
              <div className="relative group">
                <img
                  src={require('../../../Img/about-5-thumb-1.jpg')}
                  alt="Business meeting"
                  className="w-full h-64 lg:h-80 object-cover rounded-2xl shadow-lg transform group-hover:scale-105 transition-all duration-500"
                />
              </div>

              <div className="space-y-4 lg:space-y-6">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                  alt="Team collaboration"
                  className="w-full h-28 lg:h-36 object-cover rounded-2xl shadow-lg hover:scale-105 transition-all duration-500"
                  data-aos="fade-left"
                />
                <img
                  src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                  alt="Professional team"
                  className="w-full h-32 lg:h-40 object-cover rounded-2xl shadow-lg hover:scale-105 transition-all duration-500"
                  data-aos="fade-left"
                  data-aos-delay="200"
                />
              </div>
            </div>

            <div
              className="absolute bottom-4 left-4 lg:bottom-8 lg:left-8 bg-gradient-to-r button_same text-white rounded-2xl shadow-xl p-6 max-w-xs"
              data-aos="zoom-in"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm opacity-90">Call Anytime</p>
                  <p className="font-bold text-lg">(+91)9825131393</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 w-8 h-8 bg-blue-500 rounded-full opacity-20 animate-ping"></div>
            <div className="absolute top-1/3 -left-2 w-4 h-4 bg-purple-500 rounded-full opacity-30 animate-pulse"></div>
          </div>

          {/* Right Side - Content */}
          <div className="order-1 lg:order-2 space-y-8" data-aos="fade-right">
            <div className="inline-flex items-center space-x-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-[#1C74BB] font-medium text-sm">Check Our Benefits</span>
            </div>

            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight">
              We're Partner of Your
              <br />
              Innovations
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed">
              Since our founding in Surat, India, we have been helping companies of all sizes reimagine their operations, simplify workflows, and scale faster with the right technology
            </p>

            <div className="bg-blue-50 rounded-2xl p-6 lg:p-8 shadow-sm" data-aos="fade-up">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3
                    ref={textRef}
                    className="text-lg font-semibold text-gray-900 overflow-hidden transition-all duration-500 ease-in-out"
                    style={{ height: textHeight }}
                  >
                    We go beyond being just developers—we’re your strategic digital transformation partner, combining innovation, security, and scalability. Whether you are a startup chasing growth or an enterprise modernizing legacy systems, our team ensures you stay ahead in the digital age
                  </h3>
                  <button
                    onClick={toggleExpand}
                    className="text-blue-600 font-medium hover:underline focus:outline-none mt-2"
                  >
                    {isExpanded ? "Read Less ←" : "Read More →"}
                  </button>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {[
                "End-to-end IT solutions",
                "Future-ready, scalable systems",
                "Focus on business growth, not just technology",
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center space-x-3"
                  data-aos="fade-up"
                  data-aos-delay={i * 200}
                >
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-around gap-6 pt-4" data-aos="fade-up" data-aos-delay="600">
              <Link to="/Contact" onClick={() => window.scrollTo(0, 0)} className="button_same  text-white py-[14px] px-[18px] rounded-md font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105">
                Discover More
              </Link>

              <div className="flex items-center space-x-4">
                <img
                  src={require('../../../Img/lalit_sir.jpeg')}
                  alt="Lalit Periwal"
                  className="w-12 h-12 rounded-full object-cover border-2 border-gray-200"
                />
                <div>
                  <p className="font-semibold text-gray-900">Lalit Periwal</p>
                  <p className="text-gray-600 text-sm">Managing Director</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutarea;